import React from 'react';

import Button from '@components/Button';

const CustomCtas = ({ link }) => {
  return (
    <div className="w-full flex flex-col sm:flex-row items-center gap-4 justify-center mt-8">
      <Button href={`${process.env.NEXT_PUBLIC_WEB_HOST}/users/sign_up`}>
        Get started for free
      </Button>

      {link.href ? (
        <Button variant="ghost" hasArrow href={link.href} asPath={link.asPath}>
          {link.text}
        </Button>
      ) : (
        <Button variant="ghost" hasArrow onClick={link.onClick}>
          {link.text}
        </Button>
      )}
    </div>
  );
};

export default CustomCtas;
